(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Components/Avatar", [], factory);
	else if(typeof exports === 'object')
		exports["Components/Avatar"] = factory();
	else
		root["NextcloudVue"] = root["NextcloudVue"] || {}, root["NextcloudVue"]["Components/Avatar"] = factory();
})(window, function() {
return 